import { CATEGORIES, EmojiCategory } from './emojiPopupConstants';

type TranslationFunction = (translationKey: string, defaultValue: string) => string;

/**
 * Translate a category name using its localeKey.
 * This should be used within a GroupTranslatorProvider with group="popup" keyPrefix="emoji.menu".
 * The translate function will resolve the key relative to that context.
 */
export const translateCategory = (categoryName: string, translate: TranslationFunction): string => {
    const category: EmojiCategory | undefined = CATEGORIES.find((cat) => cat.name === categoryName);
    if (!category) return categoryName;

    return translate(`categories.${category.localeKey}`, category.name);
};
